// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.news-wall[data-v-54a56865] {\n  max-width: 820px;\n  margin: 0 auto;\n}\n.news-wall__list[data-v-54a56865] {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.news-wall__empty[data-v-54a56865] {\n  padding: 48px 16px;\n  text-align: center;\n  color: #64748b;\n}\n.news-wall__empty p[data-v-54a56865] {\n  margin: 8px 0 0;\n}\n", ""]);
// Exports
module.exports = exports;
